'use client';

import { useEffect, useState } from 'react';

import { APPLE_SCRIPT_LOAD_EVENT_NAME } from './constants';

export function useAppleAuth() {
  const [initSuccess, setInitSuccess] = useState(false);

  function handleLoad() {
    if (window.AppleID) {
      window.AppleID.auth.init({
        clientId: process.env.NEXT_PUBLIC_APPLE_CLIENT_ID,
        redirectURI: window.location.href,
        usePopup: true,
        scope: 'name email',
      });
      setInitSuccess(true);
    }
  }

  useEffect(() => {
    window.addEventListener(APPLE_SCRIPT_LOAD_EVENT_NAME, handleLoad);

    handleLoad();

    return () => {
      window.removeEventListener(APPLE_SCRIPT_LOAD_EVENT_NAME, handleLoad);
    };
  }, []);

  return { initSuccess };
}
